import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  matchChip: {
    height: 24,
    padding: 5,
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: theme.fonts.sizes.font10PX,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    borderRadius: 4,
  },
  positionAbsolute: {
    position: 'absolute',
    top: 20,
    left: 20,
    zIndex: 1,
  },
  silverBgColor: {
    display: 'inline-block',
    marginBottom: 50,
    backgroundColor: theme.colors.light.ghostWhite,
  },
  productCard: {
    width: 80,
    fontSize: 10,
    borderRadius: '0 0 4px 4px',
    position: 'absolute',
    top: 0,
    right: 24,
    zIndex: 1,
  },
}));
